import { render, staticRenderFns } from "./StepAccess.vue?vue&type=template&id=addf7f06"
import script from "./StepAccess.vue?vue&type=script&lang=js"
export * from "./StepAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports